import { takeLatest } from 'redux-saga/effects';

import { LOAD_MENU_ONLY_APPS, CHANGE_LOGO_APPLICATION } from "../ducks/application/actionTypes";
import { loadMenuOnlyApps, changeLogoApplication } from "../ducks/application/sagas";

export const applicationSagas = [
  takeLatest(LOAD_MENU_ONLY_APPS, loadMenuOnlyApps),
  takeLatest(CHANGE_LOGO_APPLICATION, changeLogoApplication)
]
